import React, { Component } from 'react';
import survey_footer from '../images/survey_footer.png';
import { translate } from 'react-i18next';

class SurveyFooter extends Component {
  render() {
    const { t } = this.props;
    return(
      <nav className="header-padding" >
        <div >
            <div className="text-center">
              <img alt="IOS OFFICES" className="header-banner" src={survey_footer} />
            </div>
        </div>
      </nav>
    );
  }
}

export default translate('common')(SurveyFooter);



// WEBPACK FOOTER //
// ./src/guest/SurveyFooter.js